// extracted by mini-css-extract-plugin
module.exports = {"container":"DesignPill_container__2UGHU","active":"DesignPill_active__3n9er","image":"DesignPill_image__4IcZ0","img":"DesignPill_img__23SJo"};